import { z } from 'zod';
import {
  address,
  email,
  fssai,
  gstin,
  objectId,
  optional,
  outletCode,
  phone,
  requiredText,
  text,
  timezone,
} from './common.js';

export const outletFields = {
  name: requiredText(80),
  code: outletCode,
  address,
  phone: optional(phone),
  email: optional(email),
  gstin: optional(gstin),
  fssaiNo: optional(fssai),
  timezone: timezone.optional(),
  dayCutoffMinutes: z.coerce.number().int().min(0).max(720).optional(),
  // Send orders to a kitchen (KOT tickets, kitchen display). Off for a counter that only bills.
  kitchenOrders: z.boolean().optional(),
};

export const createOutletSchema = z.strictObject(outletFields);

export const updateOutletSchema = z.strictObject({
  name: outletFields.name.optional(),
  address: address.optional(),
  phone: outletFields.phone,
  email: outletFields.email,
  gstin: outletFields.gstin,
  fssaiNo: outletFields.fssaiNo,
  timezone: outletFields.timezone,
  dayCutoffMinutes: outletFields.dayCutoffMinutes,
  kitchenOrders: outletFields.kitchenOrders,
  isActive: z.boolean().optional(),
});

export const DEVICE_KINDS = Object.freeze([
  { key: 'pos', label: 'Billing counter' },
  { key: 'kds', label: 'Kitchen display' },
  { key: 'self_order', label: 'Self-order kiosk' },
]);

export const createActivationCodeSchema = z.strictObject({
  outletId: objectId,
  kind: z.enum(DEVICE_KINDS.map((k) => k.key)).default('pos'),
  expiresInHours: z.coerce.number().int().min(1).max(168).default(24),
  note: optional(text(100)),
});

export const heartbeatSchema = z.strictObject({
  appVersion: optional(text(40)),
  lastSyncAt: z.coerce.date().optional(),
  printerStatus: z.record(z.string(), z.unknown()).optional(),
  outbox: z
    .strictObject({
      pending: z.coerce.number().int().min(0).max(1_000_000),
      failed: z.coerce.number().int().min(0).max(1_000_000),
      oldestAt: z.coerce.date().nullable().optional(),
    })
    .optional(),
});
